import { useState, Suspense } from "react";
import { lazyWithRetry } from "@/lib/lazyWithRetry";

const RestaurantRecommendDialog = lazyWithRetry(() =>
  import("./RestaurantRecommendDialog").then(m => ({ default: m.RestaurantRecommendDialog }))
);

export const FloatingRecommendBar = ({ defaultCity }: { defaultCity?: string }) => {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  return (
    <>
      <div className="fixed bottom-4 left-1/2 z-40 -translate-x-1/2 w-[calc(100%-7rem)] max-w-max">
        <div className="flex items-center gap-3 rounded-full border bg-card/95 px-3 py-2 shadow-lg backdrop-blur sm:px-4">
          <span className="hidden font-semibold text-primary sm:inline">Elindultunk!</span>
          <span className="hidden text-sm text-muted-foreground md:inline">Nincs fent a kedvenc helyed? Küldd el nekünk!</span>
          <button
            id="btn-recommend-open"
            onClick={() => { setMounted(true); setOpen(true); }}
            className="whitespace-nowrap rounded-full bg-cart px-4 py-2 text-sm font-semibold text-cart-foreground transition hover:bg-cart/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            Hely beküldése
          </button>
        </div>
      </div>
      {mounted && (
        <Suspense fallback={null}>
          <RestaurantRecommendDialog open={open} onOpenChange={setOpen} defaultCity={defaultCity} />
        </Suspense>
      )}
    </>
  );
};
